"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _tss = require("../styles/tss");
const useStyles = exports.useStyles = (0, _tss.makeTssStyles)({
  name: 'DsSeatBase',
  uniqId: 'T5k3wZ'
})((theme, _params, classes) => {
  const {
    colors,
    spacing
  } = theme.busbud;
  return {
    root: {
      position: 'relative',
      width: spacing(5),
      height: spacing(5)
    },
    icon: {},
    left: {},
    top: {},
    shape: {},
    back: {},
    paw: {},
    backLeft: {
      position: 'relative'
    },
    sm: {
      width: spacing(3),
      height: spacing(3)
    },
    md: {
      width: spacing(5),
      height: spacing(5)
    },
    lg: {
      width: spacing(6),
      height: spacing(6)
    },
    standard: {},
    recline: {
      [`&.${classes.sm}`]: {
        height: spacing(4),
        [`&.${classes.left}`]: {
          width: spacing(4),
          height: spacing(3)
        }
      },
      [`&.${classes.md}`]: {
        height: spacing(7),
        [`&.${classes.left}`]: {
          width: spacing(7),
          height: spacing(5)
        }
      },
      [`&.${classes.lg}`]: {
        height: spacing(8),
        [`&.${classes.left}`]: {
          width: spacing(8),
          height: spacing(6)
        }
      }
    },
    premium: {
      [`&.${classes.sm}`]: {
        height: spacing(6),
        [`&.${classes.left}`]: {
          width: spacing(6),
          height: spacing(3)
        }
      },
      [`&.${classes.md}`]: {
        height: spacing(10),
        [`&.${classes.left}`]: {
          width: spacing(10),
          height: spacing(5)
        }
      },
      [`&.${classes.lg}`]: {
        height: spacing(12),
        [`&.${classes.left}`]: {
          width: spacing(12),
          height: spacing(6)
        }
      }
    },
    petSeatSmStandard: {
      [`& .${classes.paw}`]: {
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
        top: '50%',
        left: '50%',
        [`&.${classes.left}`]: {
          transform: 'translate(-50%, -50%) rotate(-90deg)'
        }
      }
    },
    petSeatMdStandard: {
      [`& .${classes.paw}`]: {
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
        top: '50%',
        left: '50%',
        [`&.${classes.left}`]: {
          transform: 'translate(-50%, -50%) rotate(-90deg)'
        }
      }
    },
    petSeatLgStandard: {
      [`& .${classes.paw}`]: {
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
        top: '50%',
        left: '50%',
        [`&.${classes.left}`]: {
          transform: 'translate(-50%, -50%) rotate(-90deg)'
        }
      }
    },
    petSeatSmRecline: {
      [`& .${classes.paw}`]: {
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
        top: '50%',
        left: '50%',
        [`&.${classes.left}`]: {
          transform: 'translate(-50%, -50%) rotate(-90deg)'
        }
      }
    },
    petSeatMdRecline: {
      [`& .${classes.paw}`]: {
        position: 'absolute',
        bottom: spacing(0.5),
        right: spacing(1),
        [`&.${classes.left}`]: {
          transform: 'rotate(-90deg) translateX(-50%)',
          bottom: '50%',
          right: spacing(1)
        }
      }
    },
    petSeatLgRecline: {
      [`& .${classes.paw}`]: {
        position: 'absolute',
        bottom: spacing(1),
        right: spacing(1.5),
        [`&.${classes.left}`]: {
          transform: 'rotate(-90deg) translateX(-50%)',
          bottom: '50%',
          right: spacing(1)
        }
      }
    },
    petSeatSmPremium: {
      [`& .${classes.paw}`]: {
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
        top: '50%',
        left: '50%',
        [`&.${classes.left}`]: {
          transform: 'translate(-50%, -50%) rotate(-90deg)'
        }
      }
    },
    petSeatMdPremium: {
      [`& .${classes.paw}`]: {
        position: 'absolute',
        bottom: spacing(0.5),
        right: spacing(0.5),
        [`&.${classes.left}`]: {
          transform: 'rotate(-90deg) translateX(-50%)',
          bottom: '50%',
          right: spacing(0.5)
        }
      }
    },
    petSeatLgPremium: {
      [`& .${classes.paw}`]: {
        position: 'absolute',
        bottom: spacing(1),
        right: spacing(1),
        [`&.${classes.left}`]: {
          transform: 'rotate(-90deg) translateX(-50%)',
          bottom: '50%',
          right: spacing(1)
        }
      }
    },
    customIcon: {
      position: 'absolute',
      zIndex: 1
    },
    customSizePet: {
      position: 'absolute',
      zIndex: 1
    },
    hover: {
      [`& .${classes.shape}`]: {
        fill: colors.palette.green.regular[200],
        stroke: colors.palette.green.regular[500]
      },
      [`& .${classes.back}`]: {
        fill: colors.palette.green.regular[200],
        stroke: colors.palette.green.regular[500]
      },
      [`& .${classes.paw}`]: {
        fill: colors.palette.green.regular[500],
        color: colors.palette.green.regular[500]
      }
    },
    available: {
      [`& .${classes.shape}`]: {
        fill: colors.background.primary.opaque,
        stroke: colors.neutral[200]
      },
      [`& .${classes.back}`]: {
        stroke: colors.neutral[200],
        fill: colors.background.primary.opaque
      },
      [`& .${classes.paw}`]: {
        fill: colors.neutral[300],
        color: colors.neutral[300]
      }
    },
    selected: {
      [`& .${classes.shape}`]: {
        fill: colors.palette.green.regular[400],
        stroke: colors.palette.green.regular[600]
      },
      [`& .${classes.back}`]: {
        fill: colors.palette.green.regular[400],
        stroke: colors.palette.green.regular[600]
      },
      [`& .${classes.paw}`]: {
        fill: colors.palette.green.regular[600],
        color: colors.palette.green.regular[600]
      }
    },
    unavailableMan: {
      [`& .${classes.shape}`]: {
        fill: colors.background.informative.translucent,
        stroke: colors.border.informative.opaque
      },
      [`& .${classes.back}`]: {
        fill: colors.palette.blue.regular[100],
        stroke: colors.palette.blue.regular[300]
      }
    },
    unavailableWoman: {
      [`& .${classes.shape}`]: {
        fill: colors.background.negative.translucent,
        stroke: colors.border.negative.opaque
      },
      [`& .${classes.back}`]: {
        fill: colors.palette.red.regular[100],
        stroke: colors.palette.red.regular[300]
      }
    },
    unavailable: {
      [`& .${classes.shape}`]: {
        fill: colors.neutral[100],
        stroke: colors.neutral[200]
      },
      [`& .${classes.back}`]: {
        fill: colors.neutral[100],
        stroke: colors.neutral[200]
      },
      [`& .${classes.paw}`]: {
        fill: colors.neutral[300],
        color: colors.neutral[300]
      }
    }
  };
});